import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { NewsService } from '../../../../news/services/news-service';
import { ManagementsService } from '../../../services/managements-service';
import { ManagementInfo } from '../../../models/management-info';
import { SelectItems } from '../../../../../shared/Models/SelectItems';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-management',
  templateUrl: './add-management.component.html',
  styleUrls: ['./add-management.component.scss'],
})
export class AddManagementComponent implements OnInit {
  model = {} as ManagementInfo;
  isEdit = false;
  requiredCreateDate = [];
  config = {
    displayKey: 'description', // if objects array passed which key to be displayed defaults to description
    search: true, // true/false for the search functionlity defaults to false,
    height: 'auto', // height of the list so that if there are mor
    customComparator: () => {}, // a custom function using which user wants to sort the items.
    // default is undefined and Array.sort() will be used in that case,
    // limitTo: this.options.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
    noResultsFound: 'لا يوجد نتائج !', // text to be displayed when no items are found while searching
    searchPlaceholder: 'الادارات ', // label thats displayed in search input,
    searchOnKey: 'name', // key on which search should be performed this will be selective search.
    clearOnSelection: false, // clears search criteria when an option is selected if set to true, default is false
    inputDirection: 'ltr',
    placeholder: 'الإدارات',
    // the direction of the search input can be rtl or ltr(default)
  };
  constructor(
    private diagRef: NbDialogRef<AddManagementComponent>,
    private service: ManagementsService,
    private toast: NbToastrService,
    private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    // this.model = {} as ManagementInfo;
    if (!this.isEdit) {
      this.model.messageAR = '';
      this.model.messageEN = '';
      this.model.objectiveAR = '';
      this.model.objectiveEN = '';
      this.model.visionAR = '';
      this.model.visionEN = '';
    }

    this.loadRequiredCreateDate();
  }

  loadRequiredCreateDate() {
    this.service.getCreateNew().subscribe((res) => {
      this.requiredCreateDate = res[0].values;
    });
  }

  save() {
    if (!this.isEdit) {
      this.service.post(this.model).subscribe((res) => {
        this.diagRef.close('true');
        this.toast.show('تم إضافة إدارة جديدة بنجاح', '', { status: 'success', duration: 3000 });
      });
    } else {
      this.service.put(this.model.id, this.model).subscribe((res) => {
        this.diagRef.close('true');
        this.toast.show('تم تعديل الإدارة بنجاح', '', { status: 'success', duration: 3000 });
      });
    }
  }

  close() {
    this.diagRef.close();
  }
}
